var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconComponent)?_c('span',{staticClass:"wallet-icon",class:_vm.styleCategory},[_c(_vm.iconComponent,{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }